 import { createContext} from "react";
 
 export const RoleContext = createContext({
  role: "",
  setRole: () => {},
  roleOptions: [],
  setRoleOptions: () => {},
});